<template>
  <div>
    <router-and-print
      :data="data"
      :field="params.colDef.field"
      :use-route="attrs.useRoute"
      :use-print="attrs.usePrint"
      :route-name="attrs.routeName"
      :route-param-keys="attrs.routeParamKeys"
      :route-title="attrs.routeTitle"
      :route-permissions="attrs.routePermissions"
      :extra-route-params="attrs.extraRouteParams"
      :extra-route-data="attrs.extraRouteData"
      :print-method="()=>attrs.printMethod(params.data[params.colDef.field])"
      @linkClick="showPopover=false"
    />
  </div>
</template>
<script>
import RouterAndPrint from '@/components/Cargo/Common/routerAndPrint'

export default {
  name: 'InvoiceQueryCargoGridShowBigContent',
  components: { RouterAndPrint },
  data() {
    return {
      content: '',
      shortContent: '',
      showPopover: false,
      attrs: {}
    }
  },
  computed: {
    data() {
      const field = this.params.colDef.field
      const data = {}
      if (field === 'jobNo') {
        data[field] = this.params.data[field]
      } else {
        data[field] = this.params.data[field] ? this.params.data[field].split(',')[0] : ''
      }
      return data
    }
  },
  created() {
    const attrs = this.params.colDef.custom.attrs
    if (typeof attrs === 'function') {
      const funcResult = attrs(this.params)
      if (funcResult && typeof funcResult === 'object') {
        this.attrs = funcResult
      } else {
        this.attrs = {}
      }
    } else {
      this.attrs = attrs || {}
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>

</style>
